module.exports = require("ag-grid-react");